export default "__VITE_ASSET__JM1DEdAU__"